import { Modal, Button } from 'react-bootstrap';

function ConfirmationModal({ show, onClose, onConfirm, title, message, confirmButtonText = "Confirmer", cancelButtonText = "Annuler" }) {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="text fw-bold">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
        <p className="text-warning fw-bold text text-center">Attention : Cette action est irréversible !</p>
        <p className="text-danger fw-bold text text-center">Voulez vous continuer ? alors cliquez pour confirmer la suppression</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {cancelButtonText}
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          {confirmButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmationModal;